import React, { useEffect, useState } from "react";
import { onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useLocation } from "react-router-dom";

const UpdateStudents = () => {
  const location = useLocation();
  const [studentDetails, setStudentDetails] = useState([]);
  const [standard, setStandard] = useState("");
  const [age, setAge] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");

  
  useEffect(() => {
    onSnapshot(doc(db, "studentLists", location.state.studentId), (doc) => {
        let array=[]
        array.push({id:doc.id,...doc.data()})
        setStudentDetails(array);
    });
    }, []);


  const updateField = async () => {
    await updateDoc(doc(db, "studentLists", location.state.studentId), {
      firstName,
      middleName,
      lastName,
      standard,
      age,
    })?.then(() => {
      window.location.reload(true);
      // console.log("done");
    });
  };

  return (
    <div className="p-5  min-h-screen">
      <h1 className="text-left mb-4 ml-2 text-3xl font-semibold">
        Student List
      </h1>
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 "> Sl No.</th>
            <th className="py-3 "> First Name</th>
            <th className="py-3 ">Middle Name</th>
            <th className="py-3 "> Last Name</th>
            <th className="py-3 ">Standard</th>
            <th className="py-3 ">Email</th>
            <th className="py-3 ">Age</th>
          
          </tr>
        </thead>
        <tbody>
          {studentDetails?.map((item, index) => (
            <tr className="border-b" key={index}>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {++index}
              </td>

              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.firstName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.middleName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.lastName}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.standard}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.email}
              </td>
              <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.age}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="py-4 px-8">

        <div className="mt-20 ">
          <h1 className="font-bold text-4xl">
            Update Students Information
          </h1>
        </div>
        <div className="grid grid-cols-3 gap-4 mt-10">
          <div className="mb-4">
            <label className="block text-grey-darker text-sm font-bold mb-2">
              First Name
            </label>
            <input
              className=" border rounded w-full py-2 px-3 text-grey-darker"
              type="text"
              placeholder="Enter Your First Name "
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            /> 
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Middle Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Middle Name"
                value={middleName}
                onChange={(e) => {
                  setMiddleName(e.target.value);
                }}
              />
            </div>
          </div>
          <div>
            <div className="mb-4">
              <label className="block text-grey-darker text-sm font-bold mb-2">
                Last Name
              </label>
              <input
                className=" border rounded w-full py-2 px-3 text-grey-darker"
                type="text"
                placeholder="Enter Your Last Name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block text-grey-darker text-sm font-bold mb-2">
              Age
            </label>
            <input
              className=" border rounded w-full py-2 px-3 text-grey-darker"
              type="number"
              placeholder="Enter Your Age"
              value={age}
              onChange={(e) => {
                setAge(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="mb-4">
          <label className="block text-grey-darker text-sm font-bold mb-2">
            Standard:
          </label>
          <input
            className=" border rounded w-full py-2 px-3 text-grey-darker"
            type="text"
            placeholder="Standards"
            value={standard}
            onChange={(e) => {
              setStandard(e.target.value);
            }}
          />
        </div>
      </div>
      <div>
        <button
          className="text-white bg-green-600 py-1 px-1 rounded-md "
          onClick={updateField}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default UpdateStudents;
